import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router";
import styled from 'styled-components';
import List from '@material-ui/core/List';

const ListStyled = styled(List)`
`
const SideBarList = ({
  value,
  onChange,
  history,
  children,
  className,
  ...other
}) => {

  const checkboxes = React.Children.map(children, (child, index) => 
    React.cloneElement(child, {
      selected: (value === index),
      onClick: () => history.push(child.props.to),
      button: true,
    })
  );

  return (
    <ListStyled className={className}>
      {checkboxes}
    </ListStyled>
  );
}

SideBarList.propTypes = {
  onChange: PropTypes.func,
};

SideBarList.defaultProps = {

};

export default withRouter(SideBarList);
